import React, { useState } from 'react';
import { WifiOff, X } from 'lucide-react';

interface OfflineBannerProps {
  isOnline: boolean;
}

export const OfflineBanner: React.FC<OfflineBannerProps> = ({ isOnline }) => {
  const [dismissed, setDismissed] = useState(false);

  if (isOnline || dismissed) return null;

  return (
    <div className="bg-warning/15 border-b border-warning/30 text-warning px-4 py-2 text-xs flex items-center justify-between animate-in slide-in-from-top-2">
      <div className="flex items-center gap-2 max-w-7xl mx-auto flex-1 justify-center font-medium">
        <WifiOff className="h-4 w-4 text-warning shrink-0" />
        <span>
          <strong>Offline Mode Active</strong> — All QR generation, styling, decoding, and local history are fully functioning offline.
        </span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="p-1 text-warning hover:opacity-80 cursor-pointer"
        aria-label="Dismiss offline banner"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
